import { useIsAgentThinking } from "@/hooks/use-is-agent-thinking";
import { AgentState } from "@livekit/components-react";
import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

type VoiceAgentStateCircleContainerProps = {
  agentState: AgentState;
} & PropsWithChildren;

export const VoiceAgentStateCircleContainer = ({
  children,
  agentState,
}: VoiceAgentStateCircleContainerProps) => {
  const isThinking = useIsAgentThinking(agentState);

  return (
    <div
      className={twMerge(
        "nut-bg-magic-gradient nut-w-[120px] nut-h-[120px] nut-rounded-[50%] nut-flex nut-items-center nut-justify-center nut-p-[1px]",
        isThinking ? "nut-animate-shadow-pulse" : "",
      )}
    >
      <div className="widget-content nut-bg-white nut-cursor-pointer nut-w-[100%] nut-h-[100%] nut-rounded-[50%] nut-flex nut-items-center nut-justify-center nut-gap-[5px]">
        {children}
      </div>
    </div>
  );
};
